module.exports = __webpack_public_path__ + "img/client-do-seu-jeitim.47dcd08b.jpg";